import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiButton = (baseTheme: Theme): Partial<Components> => ({
  MuiButton: {
    styleOverrides: {
      root: {
        transition: 'background-color 0.3s ease-out',
        boxShadow: 'none',
        fontFamily: baseTheme.typography.body_medium.fontFamily,
        fontSize: baseTheme.typography.body_medium.fontSize,
        fontWeight: baseTheme.typography.body_medium.fontWeight,
        lineHeight: baseTheme.typography.body_medium.lineHeight,
        borderRadius: '8px',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
      startIcon: {
        marginRight: '4px',
      },
      textPrimary: {
        padding: '12px 24px',
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&.Mui-disabled': {
          color: baseTheme.palette.text.disabled,
          '& svg path': {
            fill: baseTheme.palette.text.disabled,
          },
        },
      },
      sizeLarge: {
        height: '56px',
      },
      sizeMedium: {
        height: '48px',
      },
      containedPrimary: {
        padding: '12px 24px',
        color: baseTheme.palette.common.white,
        backgroundColor: baseTheme.palette.brand.main,
        border: `1px solid ${baseTheme.palette.brand.main}`,
        '&:hover': {
          backgroundColor: baseTheme.palette.brand.dark,
        },
        '& svg': {
          fill: baseTheme.palette.common.white,
        },
        '&.Mui-disabled': {
          border: 'none',
        },
      },
      containedError: {
        padding: '12px 24px',
        color: baseTheme.palette.common.white,
        backgroundColor: baseTheme.palette.error.main,
        border: `1px solid ${baseTheme.palette.error.main}`,
        '&:hover': {
          backgroundColor: baseTheme.palette.error.main,
        },
      },
      containedSuccess: {
        padding: '12px 24px',
        color: baseTheme.palette.success.contrastText,
        backgroundColor: baseTheme.palette.success.main,
        border: `1px solid ${baseTheme.palette.success.main}`,
        '&:hover': {
          backgroundColor: baseTheme.palette.success.main,
        },
      },
      outlinedPrimary: {
        padding: '12px 24px',
        backgroundColor: 'transparent',
        color: baseTheme.palette.brand.main,
        border: `1px solid ${baseTheme.palette.brand.main}`,
        '&:hover': {
          border: `1px solid ${baseTheme.palette.brand.main}`,
          backgroundColor: 'transparent',
        },
      },
    },
  },
});

export const MuiButtonBase = (): Partial<Components> => ({
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
});
